<template>
  <router-view></router-view>
</template>
<script setup></script>
<style lang="scss">
html,
body,
#app {
  width: 100%;
  height: 100%;
  margin: 0;
}
</style>
